
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { isBayer } from '@/utils';
import NotificationBadge from '@/components/NotificationBadge/index.vue';
import SignalHub from '@/config/signalHub';
import Loading from '@/components/LoadingSpinner/index.vue';
import { getNotificationUnread, GetNotificationParams } from '@/services/notifications/get-notification';
import Button from '@/components/Button/index.vue';
import { Wrapper, Link, LinkInput } from './styles';
import Dropdown from '../Dropdown/index.vue';
import Input from '../Input/index.vue';
import Modal from '../Modal/index.vue';
import { MenuItem } from '../../config/types';

export default Vue.extend({
  name: 'Header',
  components: {
    Wrapper,
    Link,
    LinkInput,
    Dropdown,
    Input,
    Modal,
    NotificationBadge,
    Loading,
    Button,
  },
  props: {
    hideSearch: {
      type: Boolean,
      default: false,
    },
    notificationCount: {
      type: Number,
      default: 0,
    },
    handleFunction: {
      type: Function,
    },
    openNotificationCenter: {
      type: Boolean,
    },
    invokeMessage: String,
    notHideMenuDropDown: {
      type: Boolean,
      default: false,
    },
    reloadCondition: {
      type: Boolean,
      default: false,
    },
    isFrig: {
      type: Boolean,
      default: false,
    },
    isSearchText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['userLogged']),
  },
  data() {
    return {
      buttonsModalLogout: [
        {
          click: 'close',
          title: 'Cancelar',
          type: 'secondary',
        },
        {
          click: 'logout',
          title: this.$t('exit'),
          type: 'primary',
        },
      ],
      inputSearch: '',
      isBayer: false,
      isSearching: false,
      visible: false,
      typeUserLocal: '',
      menuList: [
        {
          click: 'showModalLogout',
          component: 'Logout',
          title: this.$t('exit'),
        },
        {
          click: 'showUserProfile',
          component: 'User',
          title: 'Perfil',
        },
      ] as Array<MenuItem>,
      menuListAdmin: [
        {
          click: 'showModalLogout',
          component: 'Logout',
          title: this.$t('exit'),
        },
      ] as Array<MenuItem>,
      showModalLogout: false,
      navVisible: false,
    };
  },
  watch: {
    inputSearch(curr: string) {
      if (curr.length === 0) {
        this.isSearching = false;
        this.$emit('clean-search');
      }
    },
  },
  methods: {
    ...mapMutations(['setUserLogged', 'setNotificationUnread', 'resetState']),
    ...mapActions(['getNotificationUnread']),
    execute() {
      if (this.handleFunction) this.handleFunction();
    },
    logout() {
      const blipChat = document.getElementById('blip-chat-container');
      if (blipChat) blipChat.remove();

      sessionStorage.setItem('userLogged', '');
      sessionStorage.setItem('chave', '');
      this.$router.replace('/login');
    },
    search(event: Event) {
      const enterEvent = event.type === 'keydown' && (event as KeyboardEvent).key === 'Enter';
      if (enterEvent) {
        this.inputSearch = (event.target as HTMLInputElement).value;
      }
      const search = event.type === 'click' || enterEvent;
      if (search && this.inputSearch.length > 0) {
        this.isSearching = true;
        this.$emit('search', this.inputSearch);
      }
    },
    async initialNotificationCount() {
      const { idUser } = this.$store.state.userLogged;
      SignalHub.invokeMessage = this.invokeMessage;
      SignalHub.start(idUser);

      const count = 0;
      // count = await getNotificationCount();
      // @ts-ignore
      this.notificationCount = count;

      this.getNotificationRequest();
    },
    navVoucher() {
      this.$router.push('/voucher');
    },
    navUser() {
      this.$router.push('/frigorifico/user');
    },
    showUserProfile() {
      console.log('Caiu');
      this.$router.push('/UserProfile');
    },
    getNotificationRequest() {
      if (this.$store.state.userLogged.groups[0].stName === 'Imac - Produtor') {
        this.typeUserLocal = 'PROD';
      } else if (this.$store.state.userLogged.groups[0].stName === 'Imac - Frigorifico') {
        this.typeUserLocal = 'FRIG';
      }
      const params: GetNotificationParams = {
        userId: this.$store.state.userLogged.idUser,
        tokenKey: this.$store.state.userLogged.company.stKey,
        typeUser: this.typeUserLocal,
      };

      getNotificationUnread(params).then((data) => {
        this.setNotificationUnread(Array.isArray(data) ? data : []);
      });
      // @ts-ignore
      this.notificationCount = this.$store.state.notificationsUnread.length;
    },
  },
  created() {
    if (!this.userLogged) {
      const inSession = JSON.parse(sessionStorage.getItem('userLogged') || '');
      this.setUserLogged(inSession);
    }
  },
  mounted() {
    this.isBayer = isBayer();
    this.initialNotificationCount();
  },
});
